export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_10642ebe-6148-421f-8c58-f1b7eade224e/artifacts/eqbzl5gh_EchoWings-Media-Logo-Transparent-1024x241.png";

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Projects", href: "/projects" },
  { label: "Pricing", href: "/pricing" },
  { label: "Reviews", href: "/reviews" },
  { label: "About", href: "/about" },
  { label: "Team", href: "/team" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];
